import { api } from '@api/api2';
import { SetMetrics } from './types';

const set = (payload: SetMetrics) => api.v1('post', 'bms/metrics', payload);

export const metricsApi = { set };
